export default {
  namespaced: true,
  state: {
    userInfo: {
      id: 'abc123',
      name: 'Aleksanteri Jaakola',
    },
  },
};
